import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { APP_ROUTES } from '@app/core/constants/routes.constants';

@Component({
  selector: 'app-unauthorized',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="unauthorized-container">
      <div class="unauthorized-content">
        <h1>403 - Unauthorized Access</h1>
        <p>Sorry, you don't have permission to access this page.</p>
        <button class="btn btn-primary" (click)="goBack()">Go Back</button>
      </div>
    </div>
  `,
  styles: [`
    .unauthorized-container {
      height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #f8f9fa;
    }
    .unauthorized-content {
      text-align: center;
      padding: 2rem;
      background: white;
      border-radius: 8px;
      box-shadow: 0 2px 10px rgba(0,0,0,0.1);
    }
    h1 {
      color: #dc3545;
      margin-bottom: 1rem;
    }
    p {
      color: #6c757d;
      margin-bottom: 2rem;
    }
    .btn {
      padding: 0.5rem 2rem;
    }
  `]
})
export class UnauthorizedComponent {
  constructor(private router: Router) {}

  goBack() {
   this.router.navigate([APP_ROUTES.WORKSPACE.ROOT, APP_ROUTES.WORKSPACE.DASHBOARD]);
  }
} 